import React, { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
//===============

const ViewPlayBack = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Background View Playback"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Background View Playback']}
				description="Manage Background View Playback Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ marginTop: '4rem', marginLeft: '5rem', width: '90%' }}>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={keyData}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default ViewPlayBack;
